import { render, staticRenderFns } from "./authenticated.vue?vue&type=template&id=f068800c&"
import script from "./authenticated.vue?vue&type=script&lang=js&"
export * from "./authenticated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports